module.exports = __webpack_public_path__ + "img/error-icons.d99f8115.svg";